export const OutputFormats = {
  jpeg: 'image/jpeg',
  png: 'image/png',
} as const;
